// TODO: this util function is build with help of ChatGPT to replace the use of eval() function

/**
 * Calculates a mathematical expression formatted as a string and returns the result as a string.
 *
 * @param expression - The mathematical expression to evaluate.
 * @returns The result of the evaluated expression as a string.
 */
export function calculateExpression(expression: string): string {
  const operators: { [key: string]: (a: number, b: number) => number } = {
    '+': (a, b) => a + b,
    '-': (a, b) => a - b,
    '*': (a, b) => a * b,
    '/': (a, b) => a / b,
  };

  const operatorPrecedence: { [key: string]: number } = {
    '+': 1,
    '-': 1,
    '*': 2,
    '/': 2,
  };

  const outputQueue: (number | string)[] = [];
  const operatorStack: string[] = [];

  const tokens = expression.match(/(\d+(\.\d+)?|\+|-|\*|\/|\(|\))/g);

  if (!tokens) {
    throw new Error('Invalid expression');
  }

  tokens.forEach((token) => {
    const numValue = parseFloat(token);
    if (!Number.isNaN(numValue)) {
      outputQueue.push(numValue);
    } else if (operators[token]) {
      while (
        operatorStack.length &&
        operatorPrecedence[operatorStack[operatorStack.length - 1]] >=
          operatorPrecedence[token]
      ) {
        outputQueue.push(operatorStack.pop()!);
      }
      operatorStack.push(token);
    } else if (token === '(') {
      operatorStack.push(token);
    } else if (token === ')') {
      while (operatorStack[operatorStack.length - 1] !== '(') {
        outputQueue.push(operatorStack.pop()!);
      }
      operatorStack.pop();
    }
  });

  while (operatorStack.length) {
    outputQueue.push(operatorStack.pop()!);
  }

  const resultStack: number[] = [];
  outputQueue.forEach((token) => {
    if (typeof token === 'number') {
      resultStack.push(token);
    } else {
      const b = resultStack.pop()!;
      const a = resultStack.pop()!;
      resultStack.push(operators[token](a, b));
    }
  });

  // Convert the final result to a string with decimals preserved
  return resultStack[0].toString();
}
